<template>
  <select class="custom-select single-tooth-selector" v-model="selectedValue" @change="$emit('input', selectedValue)">
    <option :value="0">No</option>

    <option :value="11">11</option>
    <option :value="12">12</option>
    <option :value="13">13</option>
    <option :value="14">14</option>
    <option :value="15">15</option>
    <option :value="16">16</option>
    <option :value="17">17</option>
    <option :value="18">18</option>

    <option :value="21">21</option>
    <option :value="22">22</option>
    <option :value="23">23</option>
    <option :value="24">24</option>
    <option :value="25">25</option>
    <option :value="26">26</option>
    <option :value="27">27</option>
    <option :value="28">28</option>

    <option :value="31">31</option>
    <option :value="32">32</option>
    <option :value="33">33</option>
    <option :value="34">34</option>
    <option :value="35">35</option>
    <option :value="36">36</option>
    <option :value="37">37</option>
    <option :value="38">38</option>

    <option :value="41">41</option>
    <option :value="42">42</option>
    <option :value="43">43</option>
    <option :value="44">44</option>
    <option :value="45">45</option>
    <option :value="46">46</option>
    <option :value="47">47</option>
    <option :value="48">48</option>
  </select>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      selectedValue: this.value,
    }
  },
  watch: {
    value(v) {
      this.selectedValue = v;
    }
  },
}
</script>
